import { Component, Input } from '@angular/core';
import { NgxPopupComponent } from '@components/shared/ngx-popups/ngx-popups/components/popup.component';
import { SpreadingTemplateService } from '@services/spreading-template.service';

@Component({
    selector: 'app-external-template-link',
    templateUrl: './external-template-link.component.html',
    styleUrls: ['./external-template-link.component.scss'],
    standalone: false
})
export class ExternalTemplateLinkComponent {
  @Input() popup: NgxPopupComponent;
  @Input() spreadingTemplateService: any;
  @Input() templateId: number;
  @Input() templatename: string;
  submissionPayload: any;
  description: string = `Link this template to a template on another platform using an external ID. 
  The ID must match an existing template on that platform and can only be used once. 
  To verify the connection, upload a document on the other platform - if it works, 
  the connection is successful; if not, check the ID.`;
  submitButtonText: string = 'Save';
  cancelButtonText: string = 'Cancel';
  title: string = 'EXTERNAL TEMPLATE LINK';
  inputLabel: string = 'External Template ID';
  inputPlaceholder: string = 'Template ID';
  private _templateSubtype: any;

  @Input()
  set templateSubtype(value: any) {
    this._templateSubtype = value;
    if (value) {
      this.inputValue = value;
      this.errorMessage = '';
    }
  }

  get templateSubtype(): any {
    return this._templateSubtype;
  }

  inputValue: string = '';
  submitted = false;
  errorMessage = '';

  constructor(
    private _spreadingTemplateService: SpreadingTemplateService
  ) {
  }

  onConfirm() {

    this.submitted = true;

    // Update the templateSubtype in the submission payload
    // Convert empty string to null
    const templateSubtypeValue = this.inputValue.toUpperCase().trim();
    const finalTemplateSubtype = templateSubtypeValue === '' ? null : templateSubtypeValue;

    this.submissionPayload = {
      payload: {
        name: this.templatename,
        templateSubtype: finalTemplateSubtype
      }
    };

    this._spreadingTemplateService.updateTemplate(this.templateId, this.submissionPayload.payload).subscribe(
      result => {
        this.submitted = false;
        this.errorMessage = ''; // Clear any previous errors
        this.popup.close(true, {
          confirmed: true,
          inputValue: result[0].templateSubtype
        });
      },
      error => {
        this.errorMessage = error.message;
        this.submitted = false;
      }
    );
  }

  onCancel() {
    this.popup.close(true);
  }

  onTrashClick() {
    // Clear the input value
    this.inputValue = '';
    this.errorMessage = '';
  }
}
